export var materialVegaOptionDefaults = {
    font: '"Roboto", "Helvetica", "Arial", sans-serif',
    labelPadding: 8,
    barCornerRadius: 2,
    textColor: 'rgba(0, 0, 0, 0.87)',
    secondaryTextColor: 'rgba(0, 0, 0, 0.54)',
    dividerColor: 'rgba(0, 0, 0, 0.12)',
    color: undefined,
    background: 'transparent',
    thickDomainLineWidth: 2
};
/**
 * Apply default values to user supplied material vega options
 */
export function extendDefaults(options) {
    var opts = Object.assign(materialVegaOptionDefaults, {});
    for (var key in materialVegaOptionDefaults) {
        if (key in options && options[key] !== undefined)
            opts[key] = options[key];
    }
    return opts;
}
